module.exports = __webpack_public_path__ + "media/images/black_history_month/gradient-d46903fe147b8be1c9e930746e263f76.svg";